import { Alert, Box, Button, Stack } from "@mui/material";
import { useAuth } from "@/auth/AuthContext";
import AccountPage from "./AccountPage";

/**
 * Shown instead of the app to MultiDoc staff past the two-step verification
 * deadline. The server refuses everything but the profile and the 2FA setup,
 * so this is the account page with the reason on top; once the second factor
 * is on, the refreshed session goes straight to the app.
 */
export default function MfaRequiredPage() {
  const { logout } = useAuth();
  return (
    <Box sx={{ p: 3, maxWidth: 760, mx: "auto" }}>
      <Stack spacing={2}>
        <Alert severity="warning"
               action={<Button color="inherit" size="small" onClick={() => void logout()}>Sign out</Button>}>
          MultiDoc staff must use two-step verification. Turn it on below with an
          authenticator app; the rest of the Console opens as soon as it is on.
        </Alert>
        <AccountPage />
      </Stack>
    </Box>
  );
}
